// // import React, { useEffect, useState } from 'react';
// // import { motion } from 'framer-motion';
// // import { useNavigate, useParams } from 'react-router-dom';
// // import './DignitaryInvitation.css';

// // const API_URL =
// //   process.env.REACT_APP_API_URL || 'https://lsdcnodejs-api.onrender.com';

// // export default function DignitaryInvitation() {
// //   const { code } = useParams();
// //   const navigate = useNavigate();

// //   const [invitation, setInvitation] = useState(null);
// //   const [loading, setLoading] = useState(true);
// //   const [accepting, setAccepting] = useState(false);
// //   const [error, setError] = useState('');

// //   useEffect(() => {
// //     let cancelled = false;

// //     const loadInvitation = async () => {
// //       try {
// //         setLoading(true);
// //         setError('');

// //         const response = await fetch(
// //           `${API_URL}/api/birthday/invitation/${encodeURIComponent(code)}`
// //         );

// //         const result = await response.json();

// //         if (!response.ok || !result.success) {
// //           throw new Error(
// //             result.message ||
// //               'This invitation is unavailable.'
// //           );
// //         }

// //         if (!cancelled) {
// //           setInvitation(result.data);
// //         }
// //       } catch (err) {
// //         if (!cancelled) {
// //           setError(
// //             err.message ||
// //               'This invitation is unavailable.'
// //           );
// //         }
// //       } finally {
// //         if (!cancelled) {
// //           setLoading(false);
// //         }
// //       }
// //     };

// //     if (code) {
// //       loadInvitation();
// //     }

// //     return () => {
// //       cancelled = true;
// //     };
// //   }, [code]);

// //   const acceptInvitation = async () => {
// //     try {
// //       setAccepting(true);
// //       setError('');

// //       const response = await fetch(
// //         `${API_URL}/api/birthday/invitation/${encodeURIComponent(
// //           code
// //         )}/register`,
// //         {
// //           method: 'POST',
// //           headers: {
// //             'Content-Type': 'application/json',
// //           },
// //           body: JSON.stringify({}),
// //         }
// //       );

// //       const result = await response.json();

// //       if (!response.ok || !result.success) {
// //         throw new Error(
// //           result.message ||
// //             'Unable to accept this invitation.'
// //         );
// //       }

// //       const registrationCode =
// //         result.data?.registrationCode;

// //       if (!registrationCode) {
// //         throw new Error(
// //           'Invitation accepted, but no registration code was returned.'
// //         );
// //       }

// //       navigate(`/verify/${registrationCode}`);
// //     } catch (err) {
// //       setError(
// //         err.message ||
// //           'Unable to accept this invitation.'
// //       );
// //     } finally {
// //       setAccepting(false);
// //     }
// //   };

// //   const openExistingPass = () => {
// //     if (!invitation?.registrationCode) return;

// //     navigate(
// //       `/verify/${invitation.registrationCode}`
// //     );
// //   };

// //   if (loading) {
// //     return (
// //       <div className="vip-invitation-page">
// //         <div className="vip-invitation-loading">
// //           <div className="vip-invitation-spinner" />
// //           <span>Preparing your private invitation…</span>
// //         </div>
// //       </div>
// //     );
// //   }

// //   if (error && !invitation) {
// //     return (
// //       <div className="vip-invitation-page">
// //         <motion.main
// //           className="vip-invitation-card vip-invitation-card--error"
// //           initial={{ opacity: 0, y: 24 }}
// //           animate={{ opacity: 1, y: 0 }}
// //         >
// //           <div className="vip-invitation-seal vip-invitation-seal--error">
// //             ×
// //           </div>

// //           <span className="vip-invitation-eyebrow">
// //             Private Invitation
// //           </span>

// //           <h1>
// //             Invitation Unavailable
// //           </h1>

// //           <p>
// //             {error}
// //           </p>
// //         </motion.main>
// //       </div>
// //     );
// //   }

// //   const alreadyAccepted =
// //     Boolean(
// //       invitation?.isRegistered &&
// //       invitation?.registrationCode
// //     );

// //   return (
// //     <div className="vip-invitation-page">
// //       <div className="vip-invitation-glow vip-invitation-glow--one" />
// //       <div className="vip-invitation-glow vip-invitation-glow--two" />

// //       <motion.main
// //         className="vip-invitation-card"
// //         initial={{
// //           opacity: 0,
// //           y: 30,
// //           scale: 0.98,
// //         }}
// //         animate={{
// //           opacity: 1,
// //           y: 0,
// //           scale: 1,
// //         }}
// //         transition={{
// //           duration: 0.55,
// //         }}
// //       >
// //         <div className="vip-invitation-corner vip-invitation-corner--tl" />
// //         <div className="vip-invitation-corner vip-invitation-corner--tr" />
// //         <div className="vip-invitation-corner vip-invitation-corner--bl" />
// //         <div className="vip-invitation-corner vip-invitation-corner--br" />

// //         <div className="vip-invitation-seal">
// //           VIP
// //         </div>

// //         <span className="vip-invitation-eyebrow">
// //           COS Birthday Celebration
// //         </span>

// //         <p className="vip-invitation-script">
// //           A Special Invitation
// //         </p>

// //         <h1>
// //           You're Specially Invited
// //         </h1>

// //         <div className="vip-invitation-divider">
// //           <span />
// //           <b>✦</b>
// //           <span />
// //         </div>

// //         {/* <p className="vip-invitation-for">
// //           This private invitation has been prepared for
// //         </p> */}

// //         <h2 className="vip-invitation-name">
// //           {invitation.fullName}
// //         </h2>

// //         {/* {(invitation.title ||
// //           invitation.organization) && (
// //           <p className="vip-invitation-title">
// //             {[invitation.title, invitation.organization]
// //               .filter(Boolean)
// //               .join(' · ')}
// //           </p>
// //         )} */}

// //         <section className="vip-invitation-event">
// //           <span>
// //             YOU ARE INVITED TO CELEBRATE
// //           </span>

// //           <h3>
// //             The Chief of Staff
// //           </h3>

// //           <p>
// //             LW Kingdom
// //           </p>
// //         </section>

// //         <section className="vip-invitation-access">
// //           <span className="vip-invitation-access-label">
// //             YOUR SPECIAL ACCESS
// //           </span>

// //           {(invitation.access || [
// //             'Thanksgiving Service',
// //             'Reception / Banquet',
// //           ]).map((item) => (
// //             <div
// //               className="vip-invitation-access-row"
// //               key={item}
// //             >
// //               <span>✓</span>
// //               <strong>{item}</strong>
// //             </div>
// //           ))}
// //         </section>

// //         {error && (
// //           <div
// //             className="vip-invitation-error"
// //             role="alert"
// //           >
// //             {error}
// //           </div>
// //         )}

// //         {alreadyAccepted ? (
// //           <div className="vip-invitation-accepted">
// //             <span>
// //               ✓ Invitation Accepted
// //             </span>

// //             <p>
// //               Your VIP registration is already active.
// //             </p>

// //             <motion.button
// //               type="button"
// //               onClick={openExistingPass}
// //               className="vip-invitation-primary"
// //               whileHover={{ scale: 1.01 }}
// //               whileTap={{ scale: 0.99 }}
// //             >
// //               View My Verified VIP Pass
// //             </motion.button>
// //           </div>
// //         ) : (
// //           <div className="vip-invitation-action">
// //             <p>
// //               Kindly accept this private invitation to activate
// //               your VIP event pass.
// //             </p>

// //             <motion.button
// //               type="button"
// //               onClick={acceptInvitation}
// //               className="vip-invitation-primary"
// //               disabled={accepting}
// //               whileHover={
// //                 !accepting ? { scale: 1.01 } : {}
// //               }
// //               whileTap={
// //                 !accepting ? { scale: 0.99 } : {}
// //               }
// //             >
// //               {accepting
// //                 ? 'Preparing Your Pass…'
// //                 : 'Accept Invitation'}
// //             </motion.button>
// //           </div>
// //         )}

// //         <div className="vip-invitation-ornament">
// //           <span />
// //           <b>✦</b>
// //           <b>✦</b>
// //           <b>✦</b>
// //           <span />
// //         </div>

// //         <p className="vip-invitation-private">
// //           Private invitation · Intended recipient only
// //         </p>
// //       </motion.main>
// //     </div>
// //   );
// // }


// // //VERIFIED VIP PASS




// import React, {
//   useEffect,
//   useMemo,
//   useState,
// } from 'react';

// import {
//   AnimatePresence,
//   motion,
// } from 'framer-motion';

// import {
//   useNavigate,
//   useParams,
// } from 'react-router-dom';

// import './DignitaryInvitation.css';
// //Sept

// const API_URL =
//   process.env.REACT_APP_API_URL ||
//   'https://lsdcnodejs-api.onrender.com'; 


// /* =========================================================
//    CELEBRANT SLIDER IMAGES

//    Put the images inside:
//    public/images/cos/

//    Then keep these paths exactly as below,
//    OR change them to match your actual filenames.
// ========================================================= */

// const CELEBRANT_IMAGES = [
//   {
//     src: '/assets/photos/PBA_3.png',
//     alt: 'Pastor Bisola Adeyemi',
//     position: 'center 20%',
//   },
//   {
//     src: '/assets/photos/PBA_19.png',
//     alt: 'Pastor Bisola Adeyemi',
//     position: 'center 18%',
//   },
//   {
//     src: '/assets/photos/PBA_14.png',
//     alt: 'Pastor Bisola Adeyemi',
//     position: 'center 16%',
//   },
//     {
//     src: '/assets/photos/PBA_6.png',
//     alt: 'Pastor Bisola Adeyemi',
//     position: 'center 18%',
//   },
//   {
//     src: '/assets/photos/PBA_18.png',
//     alt: 'Pastor Bisola Adeyemi',
//     position: 'center 20%',
//   },
// ];


// const SLIDE_INTERVAL_MS = 5000;


// /* =========================================================
//    MAIN COMPONENT
// ========================================================= */

// export default function DignitaryInvitation() {
//   const {
//     code,
//   } = useParams();

//   const navigate =
//     useNavigate();


//   const [
//     invitation,
//     setInvitation,
//   ] = useState(null);


//   const [
//     loading,
//     setLoading,
//   ] = useState(true);


//   const [
//     accepting,
//     setAccepting,
//   ] = useState(false);


//   const [
//     error,
//     setError,
//   ] = useState('');


//   const [
//     activeSlide,
//     setActiveSlide,
//   ] = useState(0);


//   const [
//     sliderPaused,
//     setSliderPaused,
//   ] = useState(false);


//   /* =========================================================
//      LOAD INVITATION
//   ========================================================= */

//   useEffect(() => {
//     let cancelled =
//       false;


//     const loadInvitation =
//       async () => {
//         try {
//           setLoading(
//             true
//           );

//           setError(
//             ''
//           );


//           if (!code) {
//             throw new Error(
//               'No invitation code was supplied.'
//             );
//           }


//           const response =
//             await fetch(
//               `${API_URL}/api/birthday/invitation/${encodeURIComponent(
//                 code
//               )}`
//             );


//           let result = {};

//           try {
//             result =
//               await response.json();
//           } catch {
//             result = {};
//           }


//           if (
//             !response.ok ||
//             !result.success
//           ) {
//             throw new Error(
//               result.message ||
//                 'This invitation is unavailable.'
//             );
//           }


//           if (!cancelled) {
//             setInvitation(
//               result.data
//             );
//           }

//         } catch (err) {

//           if (!cancelled) {
//             setError(
//               err.message ||
//                 'This invitation is unavailable.'
//             );
//           }

//         } finally {

//           if (!cancelled) {
//             setLoading(
//               false
//             );
//           }

//         }
//       };


//     if (code) {
//       loadInvitation();
//     } else {
//       setLoading(
//         false
//       );

//       setError(
//         'No invitation code was supplied.'
//       );
//     }


//     return () => {
//       cancelled =
//         true;
//     };

//   }, [
//     code,
//   ]);


//   /* =========================================================
//      AUTO SLIDER
//   ========================================================= */

//   useEffect(() => {
//     if (
//       sliderPaused ||
//       CELEBRANT_IMAGES.length <= 1
//     ) {
//       return undefined;
//     }


//     const timer =
//       window.setInterval(
//         () => {
//           setActiveSlide(
//             (current) =>
//               (
//                 current +
//                 1
//               ) %
//               CELEBRANT_IMAGES.length
//           );
//         },
//         SLIDE_INTERVAL_MS
//       );


//     return () => {
//       window.clearInterval(
//         timer
//       );
//     };

//   }, [
//     sliderPaused,
//   ]);


//   /* =========================================================
//      SLIDER CONTROLS
//   ========================================================= */

//   const goToPreviousSlide =
//     () => {
//       setActiveSlide(
//         (current) =>
//           (
//             current -
//             1 +
//             CELEBRANT_IMAGES.length
//           ) %
//           CELEBRANT_IMAGES.length
//       );
//     };


//   const goToNextSlide =
//     () => {
//       setActiveSlide(
//         (current) =>
//           (
//             current +
//             1
//           ) %
//           CELEBRANT_IMAGES.length
//       );
//     };


//   /* =========================================================
//      ACCEPT INVITATION
//   ========================================================= */

//   const acceptInvitation =
//     async () => {
//       try {
//         setAccepting(
//           true
//         );

//         setError(
//           ''
//         );


//         const response =
//           await fetch(
//             `${API_URL}/api/birthday/invitation/${encodeURIComponent(
//               code
//             )}/register`,
//             {
//               method:
//                 'POST',

//               headers: {
//                 'Content-Type':
//                   'application/json',
//               },

//               body:
//                 JSON.stringify(
//                   {}
//                 ),
//             }
//           );


//         let result = {};

//         try {
//           result =
//             await response.json();
//         } catch {
//           result = {};
//         }


//         if (
//           !response.ok ||
//           !result.success
//         ) {
//           throw new Error(
//             result.message ||
//               'Unable to accept this invitation.'
//           );
//         }


//         const registrationCode =
//           result.data
//             ?.registrationCode;


//         if (
//           !registrationCode
//         ) {
//           throw new Error(
//             'Invitation accepted, but no registration code was returned.'
//           );
//         }


//         navigate(
//           `/verify/${encodeURIComponent(
//             registrationCode
//           )}`
//         );

//       } catch (err) {

//         setError(
//           err.message ||
//             'Unable to accept this invitation.'
//         );

//       } finally {

//         setAccepting(
//           false
//         );

//       }
//     };


//   /* =========================================================
//      OPEN EXISTING PASS
//   ========================================================= */

//   const openExistingPass =
//     () => {
//       if (
//         !invitation
//           ?.registrationCode
//       ) {
//         setError(
//           'No active registration code was found.'
//         );

//         return;
//       }


//       navigate(
//         `/verify/${encodeURIComponent(
//           invitation.registrationCode
//         )}`
//       );
//     };


//   /* =========================================================
//      DERIVED VALUES
//   ========================================================= */

//   const dignitaryLevel =
//     invitation
//       ?.dignitaryLevel ===
//       'VVIP'
//       ? 'VVIP'
//       : 'VIP';


//   const isVvip =
//     dignitaryLevel ===
//     'VVIP';


//   const alreadyAccepted =
//     Boolean(
//       invitation
//         ?.isRegistered &&
//       invitation
//         ?.registrationCode
//     );


//   const accessItems =
//     useMemo(
//       () =>
//         invitation
//           ?.access || [
//           'Thanksgiving Service',
//           'Reception / Banquet',
//         ],
//       [
//         invitation,
//       ]
//     );


//   /* =========================================================
//      LOADING
//   ========================================================= */

//   if (loading) {
//     return (
//       <div className="vip-invitation-page">

//         <div className="vip-invitation-loading">

//           <div className="vip-invitation-spinner" />

//           <span>
//             Preparing your private invitation…
//           </span>

//         </div>

//       </div>
//     );
//   }


//   /* =========================================================
//      HARD ERROR
//   ========================================================= */

//   if (
//     error &&
//     !invitation
//   ) {
//     return (
//       <div className="vip-invitation-page">

//         <motion.main
//           className="vip-invitation-card vip-invitation-card--error"
//           initial={{
//             opacity:
//               0,

//             y:
//               24,
//           }}
//           animate={{
//             opacity:
//               1,

//             y:
//               0,
//           }}
//         >

//           <div className="vip-invitation-seal vip-invitation-seal--error">
//             ×
//           </div>


//           <span className="vip-invitation-eyebrow">
//             Private Invitation
//           </span>


//           <h1>
//             Invitation Unavailable
//           </h1>


//           <p>
//             {error}
//           </p>

//         </motion.main>

//       </div>
//     );
//   }


//   /* =========================================================
//      PAGE
//   ========================================================= */

//   return (
//     <div
//       className={`vip-invitation-page ${
//         isVvip
//           ? 'vip-invitation-page--vvip'
//           : 'vip-invitation-page--vip'
//       }`}
//     >

//       <div className="vip-invitation-glow vip-invitation-glow--one" />
//       <div className="vip-invitation-glow vip-invitation-glow--two" />


//       <motion.main
//         className={`vip-invitation-card ${
//           isVvip
//             ? 'vip-invitation-card--vvip'
//             : 'vip-invitation-card--vip'
//         }`}
//         initial={{
//           opacity:
//             0,

//           y:
//             28,

//           scale:
//             0.985,
//         }}
//         animate={{
//           opacity:
//             1,

//           y:
//             0,

//           scale:
//             1,
//         }}
//         transition={{
//           duration:
//             0.55,
//         }}
//       >

//         {/* Decorative corners */}
//         <div className="vip-invitation-corner vip-invitation-corner--tl" />
//         <div className="vip-invitation-corner vip-invitation-corner--tr" />
//         <div className="vip-invitation-corner vip-invitation-corner--bl" />
//         <div className="vip-invitation-corner vip-invitation-corner--br" />


//         {/* =====================================================
//             TOP BRAND AREA
//         ===================================================== */}

//         <header className="vip-invitation-top">


//         </header>


//         {/* =====================================================
//             PHOTO SLIDER
//         ===================================================== */}

//         <section
//           className="vip-invitation-slider"
//           onMouseEnter={() =>
//             setSliderPaused(
//               true
//             )
//           }
//           onMouseLeave={() =>
//             setSliderPaused(
//               false
//             )
//           }
//           aria-label="Pastor Bisola Adeyemi photo gallery"
//         >

//           <AnimatePresence
//             mode="wait"
//           >

//             <motion.img
//               key={
//                 CELEBRANT_IMAGES[
//                   activeSlide
//                 ].src
//               }
//               src={
//                 CELEBRANT_IMAGES[
//                   activeSlide
//                 ].src
//               }
//               alt={
//                 CELEBRANT_IMAGES[
//                   activeSlide
//                 ].alt
//               }
//               className="vip-invitation-slide-image"
//               style={{
//                 objectPosition:
//                   CELEBRANT_IMAGES[
//                     activeSlide
//                   ].position,
//               }}
//               initial={{
//                 opacity:
//                   0,

//                 scale:
//                   1.035,
//               }}
//               animate={{
//                 opacity:
//                   1,

//                 scale:
//                   1,
//               }}
//               exit={{
//                 opacity:
//                   0,
//               }}
//               transition={{
//                 duration:
//                   0.8,

//                 ease:
//                   'easeOut',
//               }}
//             />

//           </AnimatePresence>


//           <div className="vip-invitation-slider-overlay" />


//           <div className="vip-invitation-slider-copy">

//             <span>
//               SPECIAL INVITATION TO THE
//             </span>

//             <strong>
//               Thanksgiving &amp; Banquet
//             </strong>

//           </div>


//           {CELEBRANT_IMAGES.length >
//             1 && (
//             <>

//               <button
//                 type="button"
//                 className="vip-slider-arrow vip-slider-arrow--left"
//                 onClick={
//                   goToPreviousSlide
//                 }
//                 aria-label="Previous photo"
//               >
//                 ‹
//               </button>


//               <button
//                 type="button"
//                 className="vip-slider-arrow vip-slider-arrow--right"
//                 onClick={
//                   goToNextSlide
//                 }
//                 aria-label="Next photo"
//               >
//                 ›
//               </button>


//               <div className="vip-slider-dots">

//                 {CELEBRANT_IMAGES.map(
//                   (
//                     item,
//                     index
//                   ) => (

//                     <button
//                       key={
//                         item.src
//                       }
//                       type="button"
//                       className={`vip-slider-dot ${
//                         activeSlide ===
//                         index
//                           ? 'is-active'
//                           : ''
//                       }`}
//                       onClick={() =>
//                         setActiveSlide(
//                           index
//                         )
//                       }
//                       aria-label={`Show photo ${
//                         index +
//                         1
//                       }`}
//                     />

//                   )
//                 )}

//               </div>


//               <motion.div
//                 key={
//                   activeSlide
//                 }
//                 className="vip-slider-progress"
//                 initial={{
//                   scaleX:
//                     0,
//                 }}
//                 animate={{
//                   scaleX:
//                     sliderPaused
//                       ? 0
//                       : 1,
//                 }}
//                 transition={{
//                   duration:
//                     sliderPaused
//                       ? 0
//                       : SLIDE_INTERVAL_MS /
//                         1000,

//                   ease:
//                     'linear',
//                 }}
//               />

//             </>
//           )}

//         </section>


//         {/* =====================================================
//             INVITATION CONTENT
//         ===================================================== */}

//         <section className="vip-invitation-content">

//           <div
//             className={`vip-invitation-seal ${
//               isVvip
//                 ? 'vip-invitation-seal--vvip'
//                 : 'vip-invitation-seal--vip'
//             }`}
//           >
//             {dignitaryLevel}
//           </div>


//           {/* <p className="vip-invitation-script">
//             A Special Invitation
//           </p> */}


//           <h1>
//             You're Specially Invited
//           </h1>


//           <div className="vip-invitation-divider">
//             <span />
//             <b>
//               ✦
//             </b>
//             <span />
//           </div>


//           <h2 className="vip-invitation-name">
//             {
//               invitation
//                 ?.fullName
//             }
//           </h2>


//           <section className="vip-invitation-event">

//             <span>
//               IN HONOUR OF
//             </span>


//             <h3>
//               Highly Esteemed Pastor Bisola Adeyemi
//             </h3>


//             <p>
//               Chief of Staff · LoveWorld Nation
//             </p>

//           </section>


//           {/* ===================================================
//               EVENT DETAILS
//           =================================================== */}

//           <section className="vip-event-details">

//             <article className="vip-event-detail">

//               <span className="vip-event-detail-icon">
//                 29
//               </span>


//               <div>
//                 <small>
//                   DATE
//                 </small>

//                 <strong>
//                   Tuesday, 6th October 2026
//                 </strong>
//               </div>

//             </article>


//             <article className="vip-event-detail">

//               <span className="vip-event-detail-icon">
//                 10
//               </span>


//               <div>
//                 <small>
//                   THANKSGIVING
//                 </small>

//                 <strong>
//                   Bay 4 · 10:00 AM Prompt
//                 </strong>
//               </div>

//             </article>


//             <article className="vip-event-detail">

//               <span className="vip-event-detail-icon">
//                 ✦
//               </span>


//               <div>
//                 <small>
//                   BANQUET
//                 </small>

//                 <strong>
//                   The Angel Court
//                 </strong>

//                 <em>
//                   Immediately after the Thanksgiving Service
//                 </em>
//               </div>

//             </article>

//           </section>


//           {/* ===================================================
//               ACCESS
//           =================================================== */}

//           <section className="vip-invitation-access">

//             <span className="vip-invitation-access-label">
//               YOUR SPECIAL ACCESS
//             </span>


//             {accessItems.map(
//               (
//                 item
//               ) => (

//                 <div
//                   className="vip-invitation-access-row"
//                   key={
//                     item
//                   }
//                 >

//                   <span>
//                     ✓
//                   </span>

//                   <strong>
//                     {item}
//                   </strong>

//                 </div>

//               )
//             )}

//           </section>


//           {error && (

//             <div
//               className="vip-invitation-error"
//               role="alert"
//             >
//               {error}
//             </div>

//           )}


//           {/* ===================================================
//               ACTION
//           =================================================== */}

//           {alreadyAccepted ? (

//             <div className="vip-invitation-accepted">

//               <span>
//                 ✓ Invitation Accepted
//               </span>


//               <p>
//                 Your {dignitaryLevel} registration is already active.
//               </p>


//               <motion.button
//                 type="button"
//                 onClick={
//                   openExistingPass
//                 }
//                 className="vip-invitation-primary"
//                 whileHover={{
//                   scale:
//                     1.01,
//                 }}
//                 whileTap={{
//                   scale:
//                     0.99,
//                 }}
//               >
//                 View My Verified {dignitaryLevel} Pass
//               </motion.button>

//             </div>

//           ) : (

//             <div className="vip-invitation-action">

//               <p>
//                 Kindly confirm your attendance to activate
//                 your private {dignitaryLevel} event pass.
//               </p>


//               <motion.button
//                 type="button"
//                 onClick={
//                   acceptInvitation
//                 }
//                 className="vip-invitation-primary"
//                 disabled={
//                   accepting
//                 }
//                 whileHover={
//                   !accepting
//                     ? {
//                         scale:
//                           1.01,
//                       }
//                     : {}
//                 }
//                 whileTap={
//                   !accepting
//                     ? {
//                         scale:
//                           0.99,
//                       }
//                     : {}
//                 }
//               >
//                 {accepting
//                   ? 'Preparing Your Pass…'
//                   : 'Confirm Attendance'}
//               </motion.button>

//             </div>

//           )}


//           <div className="vip-invitation-ornament">
//             <span />
//             <b>
//               ✦
//             </b>
//             <b>
//               ✦
//             </b>
//             <b>
//               ✦
//             </b>
//             <span />
//           </div>


//           <p className="vip-invitation-private">
//             Private invitation · Intended recipient only
//           </p>

//         </section>

//       </motion.main>

//     </div>
//   );
// }




// import React, {
//   useEffect,
//   useMemo,
//   useState,
// } from 'react';

// import {
//   AnimatePresence,
//   motion,
// } from 'framer-motion';

// import {
//   useParams,
// } from 'react-router-dom';

// import './DignitaryInvitation.css';


// const API_URL =
//   process.env.REACT_APP_API_URL ||
//   'http://localhost:3001';


// const CELEBRANT_IMAGES = [
//   {
//     src: '/assets/photos/PBA_3.png',
//     alt: 'Pastor Bisola Adeyemi',
//     position: 'center 20%',
//   },
//   {
//     src: '/assets/photos/PBA_6.png',
//     alt: 'Pastor Bisola Adeyemi',
//     position: 'center 18%',
//   },
//   {
//     src: '/assets/photos/PBA_8.png',
//     alt: 'Pastor Bisola Adeyemi',
//     position: 'center 16%',
//   },
//   {
//     src: '/assets/photos/PBA_10.png',
//     alt: 'Pastor Bisola Adeyemi',
//     position: 'center 20%',
//   },
// ];


// const SLIDE_INTERVAL_MS =
//   5000;


// const EMPTY_PROFILE = {
//   title: '',
//   firstname: '',
//   lastname: '',
//   email: '',
//   phone_number: '',
//   country: '',
//   zone: '',
//   church: '',
// };


// const FIELD_CONFIG = {
//   title: {
//     label: 'Title',
//     type: 'text',
//     placeholder:
//       'e.g. Pastor, Dr., Mr., Mrs.',
//   },

//   firstname: {
//     label: 'First Name',
//     type: 'text',
//     placeholder:
//       'First name',
//   },

//   lastname: {
//     label: 'Last Name',
//     type: 'text',
//     placeholder:
//       'Last name',
//   },

//   email: {
//     label: 'Email Address',
//     type: 'email',
//     placeholder:
//       'Email address',
//   },

//   phone_number: {
//     label: 'Phone Number',
//     type: 'tel',
//     placeholder:
//       'Phone number',
//   },

//   country: {
//     label: 'Country',
//     type: 'text',
//     placeholder:
//       'Country',
//   },

//   zone: {
//     label: 'Zone',
//     type: 'text',
//     placeholder:
//       'Zone',
//   },

//   church: {
//     label: 'Church',
//     type: 'text',
//     placeholder:
//       'Church',
//   },
// };


// const readJson =
//   async (
//     response
//   ) => {
//     try {
//       return await response.json();
//     } catch {
//       return {};
//     }
//   };


// export default function DignitaryInvitation() {
//   const {
//     code,
//   } = useParams();


//   const [
//     invitation,
//     setInvitation,
//   ] = useState(null);


//   const [
//     loading,
//     setLoading,
//   ] = useState(true);


//   const [
//     error,
//     setError,
//   ] = useState('');


//   const [
//     activeSlide,
//     setActiveSlide,
//   ] = useState(0);


//   const [
//     sliderPaused,
//     setSliderPaused,
//   ] = useState(false);


//   const [
//     actionLoading,
//     setActionLoading,
//   ] = useState(false);


//   const [
//     kcVerified,
//     setKcVerified,
//   ] = useState(false);


//   const [
//     kcUsername,
//     setKcUsername,
//   ] = useState('');


//   const [
//     kingsPassStatus,
//     setKingsPassStatus,
//   ] = useState(
//     'not_started'
//   );


//   const [
//     missingFields,
//     setMissingFields,
//   ] = useState([]);


//   const [
//     passUrl,
//     setPassUrl,
//   ] = useState('');


//   const [
//     qrUrl,
//     setQrUrl,
//   ] = useState('');


//   const [
//     kingsPassLastError,
//     setKingsPassLastError,
//   ] = useState('');


//   const [
//     profile,
//     setProfile,
//   ] = useState(
//     EMPTY_PROFILE
//   );


//   /* =========================================================
//      APPLY KINGCHAT / KINGSPASS STATUS
//   ========================================================= */

//   const applyAccessData =
//     (
//       data
//     ) => {
//       if (!data) {
//         return;
//       }


//       setKcVerified(
//         Boolean(
//           data.kc_verified
//         )
//       );


//       setKcUsername(
//         data.kc_username ||
//         ''
//       );


//       setKingsPassStatus(
//         data.kingspass_status ||
//         'not_started'
//       );


//       setMissingFields(
//         Array.isArray(
//           data.kingspass_missing_fields
//         )
//           ? data.kingspass_missing_fields
//           : []
//       );


//       setPassUrl(
//         data.kingspass_pass_url ||
//         ''
//       );


//       setQrUrl(
//         data.kingspass_qr_url ||
//         ''
//       );


//       setKingsPassLastError(
//         data.kingspass_last_error ||
//         ''
//       );
//     };


//   /* =========================================================
//      READ KINGCHAT CALLBACK PAYLOAD
//   ========================================================= */

//   const consumeCallbackPayload =
//     () => {
//       const params =
//         new URLSearchParams(
//           window.location.search
//         );


//       const raw =
//         params.get('kc');


//       if (!raw) {
//         return null;
//       }


//       let payload = null;


//       try {
//         payload =
//           JSON.parse(raw);
//       } catch (
//         callbackError
//       ) {
//         console.error(
//           'Invalid KingsChat callback payload:',
//           callbackError
//         );
//       }


//       params.delete('kc');


//       const cleanQuery =
//         params.toString();


//       window.history.replaceState(
//         {},
//         document.title,
//         `${window.location.pathname}${
//           cleanQuery
//             ? `?${cleanQuery}`
//             : ''
//         }`
//       );


//       return payload;
//     };


//   /* =========================================================
//      INITIAL LOAD
//   ========================================================= */

//   useEffect(() => {
//     let cancelled =
//       false;


//     const bootstrap =
//       async () => {
//         try {
//           setLoading(true);
//           setError('');


//           if (!code) {
//             throw new Error(
//               'No invitation code was supplied.'
//             );
//           }


//           const callbackPayload =
//             consumeCallbackPayload();


//           const [
//             invitationResponse,
//             statusResponse,
//           ] =
//             await Promise.all([
//               fetch(
//                 `${API_URL}/api/birthday/invitation/${encodeURIComponent(
//                   code
//                 )}`
//               ),

//               fetch(
//                 `${API_URL}/api/birthday/kingschat/status/${encodeURIComponent(
//                   code
//                 )}`
//               ),
//             ]);


//           const invitationResult =
//             await readJson(
//               invitationResponse
//             );


//           const statusResult =
//             await readJson(
//               statusResponse
//             );


//           if (
//             !invitationResponse.ok ||
//             !invitationResult.success
//           ) {
//             throw new Error(
//               invitationResult.message ||
//               'This invitation is unavailable.'
//             );
//           }


//           if (!cancelled) {
//             setInvitation(
//               invitationResult.data
//             );


//             if (
//               statusResponse.ok &&
//               statusResult.success
//             ) {
//               applyAccessData(
//                 statusResult.data
//               );
//             }


//             if (
//               callbackPayload?.data
//             ) {
//               applyAccessData(
//                 callbackPayload.data
//               );
//             }


//             if (
//               callbackPayload?.status ===
//               'error'
//             ) {
//               setError(
//                 callbackPayload.message ||
//                 'KingsChat authentication failed.'
//               );
//             }
//           }


//         } catch (
//           loadError
//         ) {
//           if (!cancelled) {
//             setError(
//               loadError.message ||
//               'Unable to load this invitation.'
//             );
//           }


//         } finally {
//           if (!cancelled) {
//             setLoading(false);
//           }
//         }
//       };


//     bootstrap();


//     return () => {
//       cancelled =
//         true;
//     };

//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [
//     code,
//   ]);


//   /* =========================================================
//      SLIDER
//   ========================================================= */

//   useEffect(() => {
//     if (
//       sliderPaused ||
//       CELEBRANT_IMAGES.length <=
//         1
//     ) {
//       return undefined;
//     }


//     const timer =
//       window.setInterval(
//         () => {
//           setActiveSlide(
//             (
//               current
//             ) =>
//               (
//                 current +
//                 1
//               ) %
//               CELEBRANT_IMAGES.length
//           );
//         },
//         SLIDE_INTERVAL_MS
//       );


//     return () => {
//       window.clearInterval(
//         timer
//       );
//     };

//   }, [
//     sliderPaused,
//   ]);


//   const goToPreviousSlide =
//     () => {
//       setActiveSlide(
//         (
//           current
//         ) =>
//           (
//             current -
//             1 +
//             CELEBRANT_IMAGES.length
//           ) %
//           CELEBRANT_IMAGES.length
//       );
//     };


//   const goToNextSlide =
//     () => {
//       setActiveSlide(
//         (
//           current
//         ) =>
//           (
//             current +
//             1
//           ) %
//           CELEBRANT_IMAGES.length
//       );
//     };


//   /* =========================================================
//      ACCEPT EVENT

//      ONE PRIMARY ACTION:
//      1. Start KingsChat authentication when needed.
//      2. After authentication, backend automatically tries:
//         - KingsPass attendee creation
//         - KingsPass invitation
//      3. If data is missing, only those fields are requested.
//   ========================================================= */

//   const acceptEvent =
//     async () => {
//       try {
//         setActionLoading(true);
//         setError('');


//         if (!kcVerified) {
//           const redirectUrl =
//             `${window.location.origin}/invitation/${encodeURIComponent(
//               code
//             )}`;


//           const response =
//             await fetch(
//               `${API_URL}/api/birthday/kingschat/start/${encodeURIComponent(
//                 code
//               )}?redirect=${encodeURIComponent(
//                 redirectUrl
//               )}`
//             );


//           const result =
//             await readJson(
//               response
//             );


//           if (
//             !response.ok ||
//             !result.success
//           ) {
//             throw new Error(
//               result.message ||
//               'Unable to start KingsChat authentication.'
//             );
//           }


//           /*
//            * The backend can discover that the guest
//            * already authenticated KingsChat earlier.
//            * In that case it immediately retries KingsPass
//            * instead of redirecting to KingsChat again.
//            */
//           if (
//             result.alreadyVerified
//           ) {
//             applyAccessData(
//               result.data
//             );

//             return;
//           }


//           if (!result.authUrl) {
//             throw new Error(
//               'KingsChat login URL was not returned.'
//             );
//           }


//           window.location.assign(
//             result.authUrl
//           );

//           return;
//         }


//         /*
//          * KC already verified.
//          * Ask backend to continue/retry KingsPass.
//          */
//         const response =
//           await fetch(
//             `${API_URL}/api/birthday/kingspass/retry/${encodeURIComponent(
//               code
//             )}`,
//             {
//               method: 'POST',
//             }
//           );


//         const result =
//           await readJson(
//             response
//           );


//         if (result.data) {
//           applyAccessData(
//             result.data
//           );
//         }


//         /*
//          * 422 means KingsPass still needs profile data.
//          * This is a normal state, not a hard error.
//          */
//         if (
//           response.status ===
//           422
//         ) {
//           return;
//         }


//         if (
//           !response.ok ||
//           !result.success
//         ) {
//           throw new Error(
//             result.message ||
//             'Unable to prepare your KingsPass.'
//           );
//         }


//       } catch (
//         actionError
//       ) {
//         setError(
//           actionError.message ||
//           'Unable to accept this event.'
//         );


//       } finally {
//         setActionLoading(false);
//       }
//     };


//   /* =========================================================
//      MISSING PROFILE DATA
//   ========================================================= */

//   const handleProfileChange =
//     (
//       event
//     ) => {
//       const {
//         name,
//         value,
//       } =
//         event.target;


//       setProfile(
//         (
//           current
//         ) => ({
//           ...current,
//           [name]:
//             value,
//         })
//       );
//     };


//   const completeKingsPassProfile =
//     async (
//       event
//     ) => {
//       event.preventDefault();


//       try {
//         setActionLoading(true);
//         setError('');


//         const body = {};


//         missingFields.forEach(
//           (
//             field
//           ) => {
//             body[field] =
//               profile[field] ||
//               '';
//           }
//         );


//         const response =
//           await fetch(
//             `${API_URL}/api/birthday/kingspass/complete-profile/${encodeURIComponent(
//               code
//             )}`,
//             {
//               method:
//                 'POST',

//               headers: {
//                 'Content-Type':
//                   'application/json',
//               },

//               body:
//                 JSON.stringify(
//                   body
//                 ),
//             }
//           );


//         const result =
//           await readJson(
//             response
//           );


//         if (result.data) {
//           applyAccessData(
//             result.data
//           );
//         }


//         if (
//           response.status ===
//           422
//         ) {
//           /*
//            * Server will return the remaining
//            * missing fields, so simply keep
//            * the form visible.
//            */
//           return;
//         }


//         if (
//           !response.ok ||
//           !result.success
//         ) {
//           throw new Error(
//             result.message ||
//             'Unable to complete your KingsPass registration.'
//           );
//         }


//       } catch (
//         profileError
//       ) {
//         setError(
//           profileError.message ||
//           'Unable to complete your event profile.'
//         );


//       } finally {
//         setActionLoading(false);
//       }
//     };


//   /* =========================================================
//      DERIVED VALUES
//   ========================================================= */

//   const dignitaryLevel =
//     invitation
//       ?.dignitaryLevel ===
//       'VVIP'
//       ? 'VVIP'
//       : 'VIP';


//   const isVvip =
//     dignitaryLevel ===
//     'VVIP';


//   const accessItems =
//     useMemo(
//       () =>
//         invitation
//           ?.access || [
//           'Thanksgiving Service',
//           'Reception / Banquet',
//         ],
//       [
//         invitation,
//       ]
//     );


//   const isReady =
//     kingsPassStatus ===
//     'ready';


//   const needsProfile =
//     kingsPassStatus ===
//       'profile_required' &&
//     missingFields.length >
//       0;


//   const hasPassLink =
//     Boolean(
//       passUrl ||
//       qrUrl
//     );


//   /* =========================================================
//      LOADING
//   ========================================================= */

//   if (loading) {
//     return (
//       <div className="vip-invitation-page">

//         <div className="vip-invitation-loading">

//           <div className="vip-invitation-spinner" />

//           <span>
//             Preparing your private invitation…
//           </span>

//         </div>

//       </div>
//     );
//   }


//   /* =========================================================
//      HARD ERROR
//   ========================================================= */

//   if (
//     !invitation
//   ) {
//     return (
//       <div className="vip-invitation-page">

//         <motion.main
//           className="vip-invitation-card vip-invitation-card--error"
//           initial={{
//             opacity: 0,
//             y: 24,
//           }}
//           animate={{
//             opacity: 1,
//             y: 0,
//           }}
//         >

//           <div className="vip-invitation-seal vip-invitation-seal--error">
//             ×
//           </div>

//           <span className="vip-invitation-eyebrow">
//             Private Invitation
//           </span>

//           <h1>
//             Invitation Unavailable
//           </h1>

//           <p>
//             {error ||
//               'This invitation could not be found.'}
//           </p>

//         </motion.main>

//       </div>
//     );
//   }


//   /* =========================================================
//      PAGE
//   ========================================================= */

//   return (
//     <div
//       className={`vip-invitation-page ${
//         isVvip
//           ? 'vip-invitation-page--vvip'
//           : 'vip-invitation-page--vip'
//       }`}
//     >

//       <div className="vip-invitation-glow vip-invitation-glow--one" />
//       <div className="vip-invitation-glow vip-invitation-glow--two" />


//       <motion.main
//         className={`vip-invitation-card ${
//           isVvip
//             ? 'vip-invitation-card--vvip'
//             : 'vip-invitation-card--vip'
//         }`}
//         initial={{
//           opacity: 0,
//           y: 28,
//           scale: 0.985,
//         }}
//         animate={{
//           opacity: 1,
//           y: 0,
//           scale: 1,
//         }}
//         transition={{
//           duration: 0.55,
//         }}
//       >

//         <div className="vip-invitation-corner vip-invitation-corner--tl" />
//         <div className="vip-invitation-corner vip-invitation-corner--tr" />
//         <div className="vip-invitation-corner vip-invitation-corner--bl" />
//         <div className="vip-invitation-corner vip-invitation-corner--br" />


//         {/* =====================================================
//             PHOTO SLIDER
//         ===================================================== */}

//         <section
//           className="vip-invitation-slider"
//           onMouseEnter={() =>
//             setSliderPaused(true)
//           }
//           onMouseLeave={() =>
//             setSliderPaused(false)
//           }
//           aria-label="Pastor Bisola Adeyemi photo gallery"
//         >

//           <AnimatePresence mode="wait">

//             <motion.img
//               key={
//                 CELEBRANT_IMAGES[
//                   activeSlide
//                 ].src
//               }
//               src={
//                 CELEBRANT_IMAGES[
//                   activeSlide
//                 ].src
//               }
//               alt={
//                 CELEBRANT_IMAGES[
//                   activeSlide
//                 ].alt
//               }
//               className="vip-invitation-slide-image"
//               style={{
//                 objectPosition:
//                   CELEBRANT_IMAGES[
//                     activeSlide
//                   ].position,
//               }}
//               initial={{
//                 opacity: 0,
//                 scale: 1.03,
//               }}
//               animate={{
//                 opacity: 1,
//                 scale: 1,
//               }}
//               exit={{
//                 opacity: 0,
//               }}
//               transition={{
//                 duration: 0.75,
//                 ease: 'easeOut',
//               }}
//             />

//           </AnimatePresence>


//           <div className="vip-invitation-slider-overlay" />


//           <div className="vip-invitation-slider-top">

//             <span>
//               COS BIRTHDAY CELEBRATION
//             </span>

//             <b
//               className={`vip-slider-level vip-slider-level--${dignitaryLevel.toLowerCase()}`}
//             >
//               {dignitaryLevel}
//             </b>

//           </div>


//           <div className="vip-invitation-slider-copy">

//             <span>
//               SPECIAL INVITATION TO THE
//             </span>

//             <strong>
//               Thanksgiving &amp; Banquet
//             </strong>

//           </div>


//           {CELEBRANT_IMAGES.length >
//             1 && (
//             <>

//               <button
//                 type="button"
//                 className="vip-slider-arrow vip-slider-arrow--left"
//                 onClick={
//                   goToPreviousSlide
//                 }
//                 aria-label="Previous photo"
//               >
//                 ‹
//               </button>


//               <button
//                 type="button"
//                 className="vip-slider-arrow vip-slider-arrow--right"
//                 onClick={
//                   goToNextSlide
//                 }
//                 aria-label="Next photo"
//               >
//                 ›
//               </button>


//               <div className="vip-slider-dots">

//                 {CELEBRANT_IMAGES.map(
//                   (
//                     item,
//                     index
//                   ) => (

//                     <button
//                       key={
//                         item.src
//                       }
//                       type="button"
//                       className={`vip-slider-dot ${
//                         activeSlide ===
//                         index
//                           ? 'is-active'
//                           : ''
//                       }`}
//                       onClick={() =>
//                         setActiveSlide(
//                           index
//                         )
//                       }
//                       aria-label={`Show photo ${
//                         index +
//                         1
//                       }`}
//                     />

//                   )
//                 )}

//               </div>


//               <motion.div
//                 key={
//                   activeSlide
//                 }
//                 className="vip-slider-progress"
//                 initial={{
//                   scaleX: 0,
//                 }}
//                 animate={{
//                   scaleX:
//                     sliderPaused
//                       ? 0
//                       : 1,
//                 }}
//                 transition={{
//                   duration:
//                     sliderPaused
//                       ? 0
//                       : SLIDE_INTERVAL_MS /
//                         1000,

//                   ease:
//                     'linear',
//                 }}
//               />

//             </>
//           )}

//         </section>


//         {/* =====================================================
//             INVITATION CONTENT
//         ===================================================== */}

//         <section className="vip-invitation-content">

//           <div
//             className={`vip-invitation-seal ${
//               isVvip
//                 ? 'vip-invitation-seal--vvip'
//                 : 'vip-invitation-seal--vip'
//             }`}
//           >
//             {dignitaryLevel}
//           </div>


//           <h1>
//             You're Specially Invited
//           </h1>


//           <div className="vip-invitation-divider">
//             <span />
//             <b>
//               ✦
//             </b>
//             <span />
//           </div>


//           <p className="vip-invitation-for">
//             This private invitation has been prepared for
//           </p>


//           <h2 className="vip-invitation-name">
//             {invitation.fullName}
//           </h2>


//           <section className="vip-invitation-event">

//             <span>
//               IN HONOUR OF
//             </span>

//             <h3>
//               Highly Esteemed Pastor Bisola Adeyemi
//             </h3>

//             <p>
//               Chief of Staff · LoveWorld Nation
//             </p>

//           </section>


//           {/* ===================================================
//               EVENT DETAILS
//           =================================================== */}

//           <section className="vip-event-details">

//             <article className="vip-event-detail">

//               <span className="vip-event-detail-icon">
//                 29
//               </span>

//               <div>
//                 <small>
//                   DATE
//                 </small>

//                 <strong>
//                   Tuesday, 29 September 2026
//                 </strong>
//               </div>

//             </article>


//             <article className="vip-event-detail">

//               <span className="vip-event-detail-icon">
//                 10
//               </span>

//               <div>
//                 <small>
//                   THANKSGIVING
//                 </small>

//                 <strong>
//                   Bay 4 · 10:00 AM Prompt
//                 </strong>
//               </div>

//             </article>


//             <article className="vip-event-detail">

//               <span className="vip-event-detail-icon">
//                 ✦
//               </span>

//               <div>
//                 <small>
//                   BANQUET
//                 </small>

//                 <strong>
//                   The Angel Court
//                 </strong>

//                 <em>
//                   Immediately after the Thanksgiving Service
//                 </em>
//               </div>

//             </article>

//           </section>


//           {/* ===================================================
//               ACCESS
//           =================================================== */}

//           <section className="vip-invitation-access">

//             <span className="vip-invitation-access-label">
//               YOUR SPECIAL ACCESS
//             </span>


//             {accessItems.map(
//               (
//                 item
//               ) => (

//                 <div
//                   className="vip-invitation-access-row"
//                   key={
//                     item
//                   }
//                 >

//                   <span>
//                     ✓
//                   </span>

//                   <strong>
//                     {item}
//                   </strong>

//                 </div>

//               )
//             )}

//           </section>


//           {/* ===================================================
//               KINGCHAT + KINGSPASS ACTION
//           =================================================== */}

//           <section className="vip-kingspass-flow">

//             {!kcVerified &&
//               !isReady && (

//               <div className="vip-kingspass-action">

//                 <span className="vip-kingspass-label">
//                   SECURE EVENT ACCESS
//                 </span>


//                 <h3>
//                   Accept Your Invitation
//                 </h3>


//                 <p>
//                   Click below to accept this event.
//                   You will securely authenticate with KingsChat,
//                   and your details will be used to create your
//                   KingsPass attendee access automatically.
//                 </p>


//                 <motion.button
//                   type="button"
//                   className="vip-invitation-primary"
//                   onClick={
//                     acceptEvent
//                   }
//                   disabled={
//                     actionLoading
//                   }
//                   whileHover={
//                     !actionLoading
//                       ? {
//                           scale: 1.01,
//                         }
//                       : {}
//                   }
//                   whileTap={
//                     !actionLoading
//                       ? {
//                           scale: 0.99,
//                         }
//                       : {}
//                   }
//                 >
//                   {actionLoading
//                     ? 'Opening KingsChat…'
//                     : 'Accept Event'}
//                 </motion.button>

//               </div>

//             )}


//             {kcVerified &&
//               !isReady &&
//               !needsProfile && (

//               <div className="vip-kingspass-action">

//                 <div className="vip-kingspass-connected">

//                   <span>
//                     ✓
//                   </span>

//                   <div>
//                     <strong>
//                       KingsChat Verified
//                     </strong>

//                     {kcUsername && (
//                       <small>
//                         @{kcUsername}
//                       </small>
//                     )}
//                   </div>

//                 </div>


//                 <h3>
//                   Complete Your Event Access
//                 </h3>


//                 <p>
//                   Your KingsChat identity is verified.
//                   Continue to create your KingsPass attendee
//                   access and receive your event pass.
//                 </p>


//                 <motion.button
//                   type="button"
//                   className="vip-invitation-primary"
//                   onClick={
//                     acceptEvent
//                   }
//                   disabled={
//                     actionLoading
//                   }
//                 >
//                   {actionLoading
//                     ? 'Preparing KingsPass…'
//                     : 'Complete Event Access'}
//                 </motion.button>

//               </div>

//             )}


//             {needsProfile && (

//               <form
//                 className="vip-kingspass-profile"
//                 onSubmit={
//                   completeKingsPassProfile
//                 }
//               >

//                 <div className="vip-kingspass-connected">

//                   <span>
//                     ✓
//                   </span>

//                   <div>
//                     <strong>
//                       KingsChat Verified
//                     </strong>

//                     {kcUsername && (
//                       <small>
//                         @{kcUsername}
//                       </small>
//                     )}
//                   </div>

//                 </div>


//                 <span className="vip-kingspass-label">
//                   ALMOST DONE
//                 </span>


//                 <h3>
//                   Complete Your Event Profile
//                 </h3>


//                 <p>
//                   KingsPass already received the details available
//                   from KingsChat. Please provide only the remaining
//                   information below.
//                 </p>


//                 <div className="vip-kingspass-fields">

//                   {missingFields.map(
//                     (
//                       field
//                     ) => {
//                       const config =
//                         FIELD_CONFIG[
//                           field
//                         ];


//                       if (!config) {
//                         return null;
//                       }


//                       return (
//                         <label
//                           className="vip-kingspass-field"
//                           key={
//                             field
//                           }
//                         >

//                           <span>
//                             {config.label}
//                           </span>


//                           <input
//                             type={
//                               config.type
//                             }
//                             name={
//                               field
//                             }
//                             value={
//                               profile[field] ||
//                               ''
//                             }
//                             onChange={
//                               handleProfileChange
//                             }
//                             placeholder={
//                               config.placeholder
//                             }
//                             required
//                           />

//                         </label>
//                       );

//                     }
//                   )}

//                 </div>


//                 <motion.button
//                   type="submit"
//                   className="vip-invitation-primary"
//                   disabled={
//                     actionLoading
//                   }
//                 >
//                   {actionLoading
//                     ? 'Creating Your KingsPass…'
//                     : 'Complete & Accept Event'}
//                 </motion.button>

//               </form>

//             )}


//             {isReady && (

//               <div className="vip-kingspass-ready">

//                 <div className="vip-kingspass-ready-icon">
//                   ✓
//                 </div>


//                 <span className="vip-kingspass-success-label">
//                   EVENT ACCEPTED
//                 </span>


//                 <h3>
//                   Your KingsPass Is Ready
//                 </h3>


//                 <p>
//                   Your attendee access has been created successfully.
//                   KingsPass will send your event pass details and
//                   secure QR access to your authenticated KingsChat
//                   account.
//                 </p>


//                 {kcUsername && (

//                   <div className="vip-kingspass-user">
//                     KingsChat · @{kcUsername}
//                   </div>

//                 )}


//                 {hasPassLink ? (

//                   <a
//                     href={
//                       passUrl ||
//                       qrUrl
//                     }
//                     className="vip-invitation-primary vip-kingspass-open-link"
//                     target="_blank"
//                     rel="noreferrer"
//                   >
//                     Open My KingsPass
//                   </a>

//                 ) : (

//                   <div className="vip-kingspass-check-kc">

//                     <strong>
//                       Check your KingsChat
//                     </strong>

//                     <span>
//                       Your KingsPass invitation contains your
//                       event pass / QR access link.
//                     </span>

//                   </div>

//                 )}

//               </div>

//             )}


//             {kingsPassStatus ===
//               'failed' &&
//               kcVerified &&
//               !isReady && (

//               <div className="vip-kingspass-retry">

//                 <strong>
//                   KingsChat is verified.
//                 </strong>

//                 <p>
//                   KingsPass could not be completed yet.
//                   You do not need to log in again.
//                 </p>

//                 <button
//                   type="button"
//                   onClick={
//                     acceptEvent
//                   }
//                   disabled={
//                     actionLoading
//                   }
//                 >
//                   {actionLoading
//                     ? 'Retrying…'
//                     : 'Retry KingsPass'}
//                 </button>

//               </div>

//             )}


//             {(
//               error ||
//               kingsPassLastError
//             ) && (

//               <div
//                 className="vip-invitation-error"
//                 role="alert"
//               >
//                 {error ||
//                   kingsPassLastError}
//               </div>

//             )}

//           </section>


//           <div className="vip-invitation-ornament">
//             <span />
//             <b>✦</b>
//             <b>✦</b>
//             <b>✦</b>
//             <span />
//           </div>


//           <p className="vip-invitation-private">
//             Private invitation · Intended recipient only
//           </p>

//         </section>

//       </motion.main>

//     </div>
//   );
// }




// import React, {

//   useEffect,

//   useMemo,

//   useState,

// } from 'react';

// import {

//   AnimatePresence,

//   motion,

// } from 'framer-motion';

// import {

//   useNavigate,

//   useParams,

// } from 'react-router-dom';

// import './DignitaryInvitation.css';

// //Sept

// const API_URL =

//   process.env.REACT_APP_API_URL ||

//   'http://localhost:3001';

// /* =========================================================

//    CELEBRANT SLIDER IMAGES

//    Put the images inside:

//    public/images/cos/

//    Then keep these paths exactly as below,

//    OR change them to match your actual filenames.

// ========================================================= */

// const CELEBRANT_IMAGES = [

//   {

//     src: '/assets/photos/PBA_3.png',

//     alt: 'Pastor Bisola Adeyemi',

//     position: 'center 20%',

//   },

//   {

//     src: '/assets/photos/PBA_19.png',

//     alt: 'Pastor Bisola Adeyemi',

//     position: 'center 18%',

//   },

//   {

//     src: '/assets/photos/PBA_14.png',

//     alt: 'Pastor Bisola Adeyemi',

//     position: 'center 16%',

//   },

//   {

//     src: '/assets/photos/PBA_6.png',

//     alt: 'Pastor Bisola Adeyemi',

//     position: 'center 18%',

//   },

//   {

//     src: '/assets/photos/PBA_18.png',

//     alt: 'Pastor Bisola Adeyemi',

//     position: 'center 20%',

//   },

// ];

// const SLIDE_INTERVAL_MS = 5000;

// const readJson = async (response) => {

//   try {

//     return await response.json();

//   } catch {

//     return {};

//   }

// };

// /* =========================================================

//    MAIN COMPONENT

// ========================================================= */

// export default function DignitaryInvitation() {

//   const {

//     code,

//   } = useParams();

//   const navigate =

//     useNavigate();

//   const [

//     invitation,

//     setInvitation,

//   ] = useState(null);

//   const [

//     loading,

//     setLoading,

//   ] = useState(true);

//   const [

//     accepting,

//     setAccepting,

//   ] = useState(false);

//   const [

//     error,

//     setError,

//   ] = useState('');

//   const [

//     activeSlide,

//     setActiveSlide,

//   ] = useState(0);

//   const [

//     sliderPaused,

//     setSliderPaused,

//   ] = useState(false);

//   /* =========================================================

//      LOAD INVITATION

//   ========================================================= */

//   useEffect(() => {

//     let cancelled =

//       false;

//     const loadInvitation =

//       async () => {

//         try {

//           setLoading(

//             true

//           );

//           setError(

//             ''

//           );


//           const params =

//             new URLSearchParams(

//               window.location.search

//             );

//           const kcError =

//             params.get('kc_error');

//           if (kcError) {

//             setError(kcError);

//             params.delete('kc_error');

//             const cleanQuery =

//               params.toString();

//             window.history.replaceState(

//               {},

//               document.title,

//               `${window.location.pathname}${

//                 cleanQuery

//                   ? `?${cleanQuery}`

//                   : ''

//               }`

//             );

//           }

//           if (!code) {

//             throw new Error(

//               'No invitation code was supplied.'

//             );

//           }

//           const response =

//             await fetch(

//               `${API_URL}/api/birthday/invitation/${encodeURIComponent(

//                 code

//               )}`

//             );

//           let result = {};

//           try {

//             result =

//               await response.json();

//           } catch {

//             result = {};

//           }

//           if (

//             !response.ok ||

//             !result.success

//           ) {

//             throw new Error(

//               result.message ||

//                 'This invitation is unavailable.'

//             );

//           }

//           if (!cancelled) {

//             setInvitation(

//               result.data

//             );

//           }

//         } catch (err) {

//           if (!cancelled) {

//             setError(

//               err.message ||

//                 'This invitation is unavailable.'

//             );

//           }

//         } finally {

//           if (!cancelled) {

//             setLoading(

//               false

//             );

//           }

//         }

//       };

//     if (code) {

//       loadInvitation();

//     } else {

//       setLoading(

//         false

//       );

//       setError(

//         'No invitation code was supplied.'

//       );

//     }

//     return () => {

//       cancelled =

//         true;

//     };

//   }, [

//     code,

//   ]);

//   /* =========================================================

//      AUTO SLIDER

//   ========================================================= */

//   useEffect(() => {

//     if (

//       sliderPaused ||

//       CELEBRANT_IMAGES.length <= 1

//     ) {

//       return undefined;

//     }

//     const timer =

//       window.setInterval(

//         () => {

//           setActiveSlide(

//             (current) =>

//               (

//                 current +

//                 1

//               ) %

//               CELEBRANT_IMAGES.length

//           );

//         },

//         SLIDE_INTERVAL_MS

//       );

//     return () => {

//       window.clearInterval(

//         timer

//       );

//     };

//   }, [

//     sliderPaused,

//   ]);

//   /* =========================================================

//      SLIDER CONTROLS

//   ========================================================= */

//   const goToPreviousSlide =

//     () => {

//       setActiveSlide(

//         (current) =>

//           (

//             current -

//             1 +

//             CELEBRANT_IMAGES.length

//           ) %

//           CELEBRANT_IMAGES.length

//       );

//     };

//   const goToNextSlide =

//     () => {

//       setActiveSlide(

//         (current) =>

//           (

//             current +

//             1

//           ) %

//           CELEBRANT_IMAGES.length

//       );

//     };

//   /* =========================================================

//      ACCEPT INVITATION

//      FINAL FLOW:

//      Accept Event

//      -> KingsChat login

//      -> backend receives KingsChat profile

//      -> backend creates local registration code + QR

//      -> backend redirects directly to /verify/:registrationCode

//   ========================================================= */

//   const acceptInvitation =

//     async () => {

//       try {

//         setAccepting(

//           true

//         );

//         setError(

//           ''

//         );

//         const redirectUrl =

//           `${window.location.origin}/invitation/${encodeURIComponent(

//             code

//           )}`;

//         const response =

//           await fetch(

//             `${API_URL}/api/birthday/kingschat/start/${encodeURIComponent(

//               code

//             )}?redirect=${encodeURIComponent(

//               redirectUrl

//             )}`

//           );

//         const result =

//           await readJson(

//             response

//           );

//         if (

//           !response.ok ||

//           !result.success

//         ) {

//           throw new Error(

//             result.message ||

//             'Unable to start KingsChat authentication.'

//           );

//         }

//         /*

//          * Already authenticated for THIS invitation.

//          * Open the existing locally generated pass.

//          */

//         if (

//           result.alreadyVerified

//         ) {

//           const registrationCode =

//             result.data

//               ?.registrationCode;

//           if (

//             !registrationCode

//           ) {

//             throw new Error(

//               'KingsChat is verified, but no registration code was returned.'

//             );

//           }

//           navigate(

//             `/verify/${encodeURIComponent(

//               registrationCode

//             )}`

//           );

//           return;

//         }

//         if (

//           !result.authUrl

//         ) {

//           throw new Error(

//             'KingsChat login URL was not returned.'

//           );

//         }

//         /*

//          * On successful KC authentication, the BACKEND callback

//          * redirects directly to /verify/:registrationCode.

//          */

//         window.location.assign(

//           result.authUrl

//         );

//       } catch (

//         err

//       ) {

//         setError(

//           err.message ||

//           'Unable to accept this invitation.'

//         );

//       } finally {

//         setAccepting(

//           false

//         );

//       }

//     };

// /* =========================================================

//      OPEN EXISTING PASS

//   ========================================================= */

//   const openExistingPass =

//     () => {

//       if (

//         !invitation

//           ?.registrationCode

//       ) {

//         setError(

//           'No active registration code was found.'

//         );

//         return;

//       }

//       navigate(

//         `/verify/${encodeURIComponent(

//           invitation.registrationCode

//         )}`

//       );

//     };

//   /* =========================================================

//      DERIVED VALUES

//   ========================================================= */

//   const dignitaryLevel =

//     invitation

//       ?.dignitaryLevel ===

//       'VVIP'

//       ? 'VVIP'

//       : 'VIP';

//   const isVvip =

//     dignitaryLevel ===

//     'VVIP';

//   const alreadyAccepted =

//     Boolean(

//       invitation

//         ?.isRegistered &&

//       invitation

//         ?.registrationCode

//     );

//   const accessItems =

//     useMemo(

//       () =>

//         invitation

//           ?.access || [

//           'Thanksgiving Service',

//           'Reception / Banquet',

//         ],

//       [

//         invitation,

//       ]

//     );

//   /* =========================================================

//      LOADING

//   ========================================================= */

//   if (loading) {

//     return (

//       <div className="vip-invitation-page">

//         <div className="vip-invitation-loading">

//           <div className="vip-invitation-spinner" />

//           <span>

//             Preparing your private invitation…

//           </span>

//         </div>

//       </div>

//     );

//   }

//   /* =========================================================

//      HARD ERROR

//   ========================================================= */

//   if (

//     error &&

//     !invitation

//   ) {

//     return (

//       <div className="vip-invitation-page">

//         <motion.main

//           className="vip-invitation-card vip-invitation-card--error"

//           initial={{

//             opacity:

//               0,

//             y:

//               24,

//           }}

//           animate={{

//             opacity:

//               1,

//             y:

//               0,

//           }}

//         >

//           <div className="vip-invitation-seal vip-invitation-seal--error">

//             ×

//           </div>

//           <span className="vip-invitation-eyebrow">

//             Private Invitation

//           </span>

//           <h1>

//             Invitation Unavailable

//           </h1>

//           <p>

//             {error}

//           </p>

//         </motion.main>

//       </div>

//     );

//   }

//   /* =========================================================

//      PAGE

//   ========================================================= */

//   return (

//     <div

//       className={`vip-invitation-page ${

//         isVvip

//           ? 'vip-invitation-page--vvip'

//           : 'vip-invitation-page--vip'

//       }`}

//     >

//       <div className="vip-invitation-glow vip-invitation-glow--one" />

//       <div className="vip-invitation-glow vip-invitation-glow--two" />

//       <motion.main

//         className={`vip-invitation-card ${

//           isVvip

//             ? 'vip-invitation-card--vvip'

//             : 'vip-invitation-card--vip'

//         }`}

//         initial={{

//           opacity:

//             0,

//           y:

//             28,

//           scale:

//             0.985,

//         }}

//         animate={{

//           opacity:

//             1,

//           y:

//             0,

//           scale:

//             1,

//         }}

//         transition={{

//           duration:

//             0.55,

//         }}

//       >

//         {/* Decorative corners */}

//         <div className="vip-invitation-corner vip-invitation-corner--tl" />

//         <div className="vip-invitation-corner vip-invitation-corner--tr" />

//         <div className="vip-invitation-corner vip-invitation-corner--bl" />

//         <div className="vip-invitation-corner vip-invitation-corner--br" />

//         {/* =====================================================

//             TOP BRAND AREA

//         ===================================================== */}

//         <header className="vip-invitation-top">

//         </header>

//         {/* =====================================================

//             PHOTO SLIDER

//         ===================================================== */}

//         <section

//           className="vip-invitation-slider"

//           onMouseEnter={() =>

//             setSliderPaused(

//               true

//             )

//           }

//           onMouseLeave={() =>

//             setSliderPaused(

//               false

//             )

//           }

//           aria-label="Pastor Bisola Adeyemi photo gallery"

//         >

//           <AnimatePresence

//             mode="wait"

//           >

//             <motion.img

//               key={

//                 CELEBRANT_IMAGES[

//                   activeSlide

//                 ].src

//               }

//               src={

//                 CELEBRANT_IMAGES[

//                   activeSlide

//                 ].src

//               }

//               alt={

//                 CELEBRANT_IMAGES[

//                   activeSlide

//                 ].alt

//               }

//               className="vip-invitation-slide-image"

//               style={{

//                 objectPosition:

//                   CELEBRANT_IMAGES[

//                     activeSlide

//                   ].position,

//               }}

//               initial={{

//                 opacity:

//                   0,

//                 scale:

//                   1.035,

//               }}

//               animate={{

//                 opacity:

//                   1,

//                 scale:

//                   1,

//               }}

//               exit={{

//                 opacity:

//                   0,

//               }}

//               transition={{

//                 duration:

//                   0.8,

//                 ease:

//                   'easeOut',

//               }}

//             />

//           </AnimatePresence>

//           <div className="vip-invitation-slider-overlay" />

//           <div className="vip-invitation-slider-copy">

//             <span>

//               SPECIAL INVITATION TO THE

//             </span>

//             <strong>

//               Thanksgiving &amp; Banquet

//             </strong>

//           </div>

//           {CELEBRANT_IMAGES.length >

//             1 && (

//             <>

//               <button

//                 type="button"

//                 className="vip-slider-arrow vip-slider-arrow--left"

//                 onClick={

//                   goToPreviousSlide

//                 }

//                 aria-label="Previous photo"

//               >

//                 ‹

//               </button>

//               <button

//                 type="button"

//                 className="vip-slider-arrow vip-slider-arrow--right"

//                 onClick={

//                   goToNextSlide

//                 }

//                 aria-label="Next photo"

//               >

//                 ›

//               </button>

//               <div className="vip-slider-dots">

//                 {CELEBRANT_IMAGES.map(

//                   (

//                     item,

//                     index

//                   ) => (

//                     <button

//                       key={

//                         item.src

//                       }

//                       type="button"

//                       className={`vip-slider-dot ${

//                         activeSlide ===

//                         index

//                           ? 'is-active'

//                           : ''

//                       }`}

//                       onClick={() =>

//                         setActiveSlide(

//                           index

//                         )

//                       }

//                       aria-label={`Show photo ${

//                         index +

//                         1

//                       }`}

//                     />

//                   )

//                 )}

//               </div>

//               <motion.div

//                 key={

//                   activeSlide

//                 }

//                 className="vip-slider-progress"

//                 initial={{

//                   scaleX:

//                     0,

//                 }}

//                 animate={{

//                   scaleX:

//                     sliderPaused

//                       ? 0

//                       : 1,

//                 }}

//                 transition={{

//                   duration:

//                     sliderPaused

//                       ? 0

//                       : SLIDE_INTERVAL_MS /

//                         1000,

//                   ease:

//                     'linear',

//                 }}

//               />

//             </>

//           )}

//         </section>

//         {/* =====================================================

//             INVITATION CONTENT

//         ===================================================== */}

//         <section className="vip-invitation-content">

//           <div

//             className={`vip-invitation-seal ${

//               isVvip

//                 ? 'vip-invitation-seal--vvip'

//                 : 'vip-invitation-seal--vip'

//             }`}

//           >

//             {dignitaryLevel}

//           </div>

//           {/* <p className="vip-invitation-script">

//             A Special Invitation

//           </p> */}

//           <h1>

//             You're Specially Invited

//           </h1>

//           <div className="vip-invitation-divider">

//             <span />

//             <b>

//               ✦

//             </b>

//             <span />

//           </div>

//           <h2 className="vip-invitation-name">

//             {

//               invitation

//                 ?.fullName

//             }

//           </h2>

//           <section className="vip-invitation-event">

//             <span>

//               IN HONOUR OF

//             </span>

//             <h3>

//               Highly Esteemed Pastor Bisola Adeyemi

//             </h3>

//             <p>

//               Chief of Staff · LoveWorld Nation

//             </p>

//           </section>

//           {/* ===================================================

//               EVENT DETAILS

//           =================================================== */}

//           <section className="vip-event-details">

//             <article className="vip-event-detail">

//               <span className="vip-event-detail-icon">

//                 29

//               </span>

//               <div>

//                 <small>

//                   DATE

//                 </small>

//                 <strong>

//                   Tuesday, 6th October 2026

//                 </strong>

//               </div>

//             </article>

//             <article className="vip-event-detail">

//               <span className="vip-event-detail-icon">

//                 10

//               </span>

//               <div>

//                 <small>

//                   THANKSGIVING

//                 </small>

//                 <strong>

//                   Bay 4 · 10:00 AM Prompt

//                 </strong>

//               </div>

//             </article>

//             <article className="vip-event-detail">

//               <span className="vip-event-detail-icon">

//                 ✦

//               </span>

//               <div>

//                 <small>

//                   BANQUET

//                 </small>

//                 <strong>

//                   The Angel Court

//                 </strong>

//                 <em>

//                   Immediately after the Thanksgiving Service

//                 </em>

//               </div>

//             </article>

//           </section>

//           {/* ===================================================

//               ACCESS

//           =================================================== */}

//           <section className="vip-invitation-access">

//             <span className="vip-invitation-access-label">

//               YOUR SPECIAL ACCESS

//             </span>

//             {accessItems.map(

//               (

//                 item

//               ) => (

//                 <div

//                   className="vip-invitation-access-row"

//                   key={

//                     item

//                   }

//                 >

//                   <span>

//                     ✓

//                   </span>

//                   <strong>

//                     {item}

//                   </strong>

//                 </div>

//               )

//             )}

//           </section>

//           {error && (

//             <div

//               className="vip-invitation-error"

//               role="alert"

//             >

//               {error}

//             </div>

//           )}

//           {/* ===================================================

//               ACTION

//           =================================================== */}

//           {alreadyAccepted ? (

//             <div className="vip-invitation-accepted">

//               <span>

//                 ✓ Invitation Accepted

//               </span>

//               <p>

//                 Your {dignitaryLevel} registration is already active.

//               </p>

//               <motion.button

//                 type="button"

//                 onClick={

//                   openExistingPass

//                 }

//                 className="vip-invitation-primary"

//                 whileHover={{

//                   scale:

//                     1.01,

//                 }}

//                 whileTap={{

//                   scale:

//                     0.99,

//                 }}

//               >

//                 View My Verified {dignitaryLevel} Pass

//               </motion.button>

//             </div>

//           ) : (

//             <div className="vip-invitation-action">

//               <p>

//                 Click Accept Event to authenticate with KingsChat and activate

//                 your private {dignitaryLevel} event pass.

//               </p>

//               <motion.button

//                 type="button"

//                 onClick={

//                   acceptInvitation

//                 }

//                 className="vip-invitation-primary"

//                 disabled={

//                   accepting

//                 }

//                 whileHover={

//                   !accepting

//                     ? {

//                         scale:

//                           1.01,

//                       }

//                     : {}

//                 }

//                 whileTap={

//                   !accepting

//                     ? {

//                         scale:

//                           0.99,

//                       }

//                     : {}

//                 }

//               >

//                 {accepting

//                   ? 'Preparing Your Pass…'

//                   : 'Confirm Attendance'}

//               </motion.button>

//             </div>

//           )}

//           <div className="vip-invitation-ornament">

//             <span />

//             <b>

//               ✦

//             </b>

//             <b>

//               ✦

//             </b>

//             <b>

//               ✦

//             </b>

//             <span />

//           </div>

//           <p className="vip-invitation-private">

//             Private invitation · Intended recipient only

//           </p>

//         </section>

//       </motion.main>

//     </div>

//   );

// }

//PBA



import React, {

  useEffect,

  useMemo,

  useState,

} from 'react';

import {

  AnimatePresence,

  motion,

} from 'framer-motion';

import {

  useNavigate,

  useParams,

} from 'react-router-dom';

import './DignitaryInvitation.css';

//Sept

const API_URL =
  process.env.REACT_APP_API_URL ||
  (
    window.location.hostname === 'localhost'
      ? 'http://localhost:3001'
      : 'https://lsdcnodejs-api.onrender.com'
  );

/* =========================================================

   CELEBRANT SLIDER IMAGES

   Put the images inside:

   public/images/cos/

   Then keep these paths exactly as below,

   OR change them to match your actual filenames.

========================================================= */

const CELEBRANT_IMAGES = [

  {

    src: '/assets/photos/PBA_3.png',

    alt: 'Pastor Bisola Adeyemi',

    position: 'center 20%',

  },

  {

    src: '/assets/photos/PBA_19.png',

    alt: 'Pastor Bisola Adeyemi',

    position: 'center 18%',

  },

  {

    src: '/assets/photos/PBA_14.png',

    alt: 'Pastor Bisola Adeyemi',

    position: 'center 16%',

  },

  {

    src: '/assets/photos/PBA_6.png',

    alt: 'Pastor Bisola Adeyemi',

    position: 'center 18%',

  },

  {

    src: '/assets/photos/PBA_18.png',

    alt: 'Pastor Bisola Adeyemi',

    position: 'center 20%',

  },

];

const SLIDE_INTERVAL_MS = 5000;

const readJson = async (response) => {

  try {

    return await response.json();

  } catch {

    return {};

  }

};

/* =========================================================

   MAIN COMPONENT

========================================================= */

export default function DignitaryInvitation() {

  const {

    code,

  } = useParams();

  const navigate =

    useNavigate();

  const [

    invitation,

    setInvitation,

  ] = useState(null);

  const [

    loading,

    setLoading,

  ] = useState(true);

  const [

    accepting,

    setAccepting,

  ] = useState(false);

  const [

    error,

    setError,

  ] = useState('');

  const [

    activeSlide,

    setActiveSlide,

  ] = useState(0);

  const [

    sliderPaused,

    setSliderPaused,

  ] = useState(false);

  /* =========================================================
     LOAD INVITATION

     The user must never confirm twice.

     Priority:
     1. If a local registrationCode exists -> go to /verify immediately.
     2. If KingsChat is already verified but no local pass exists ->
        call /kingschat/finalize/:code automatically.
     3. Only a genuinely fresh invitation shows the Accept Event button.
  ========================================================= */

  useEffect(() => {

    let cancelled = false;

    const goToVerify = (
      registrationCode
    ) => {

      if (
        !registrationCode ||
        cancelled
      ) {
        return false;
      }

      navigate(
        `/verify/${encodeURIComponent(
          registrationCode
        )}`,
        {
          replace: true,
        }
      );

      return true;

    };

    const finalizeVerifiedPass =
      async () => {

        const response =
          await fetch(
            `${API_URL}/api/birthday/kingschat/finalize/${encodeURIComponent(
              code
            )}`,
            {
              method: 'POST',
            }
          );

        const result =
          await readJson(
            response
          );

        if (
          !response.ok ||
          !result.success
        ) {

          throw new Error(
            result.message ||
            'KingsChat is verified, but your local event pass could not be created.'
          );

        }

        const registrationCode =
          result.data
            ?.registrationCode;

        if (
          !registrationCode
        ) {

          throw new Error(
            'Your verified event pass was created without a registration code.'
          );

        }

        goToVerify(
          registrationCode
        );

        return registrationCode;

      };

    const loadInvitation =
      async () => {

        try {

          setLoading(
            true
          );

          setError(
            ''
          );

          if (!code) {

            throw new Error(
              'No invitation code was supplied.'
            );

          }

          /*
           * Only actual KC authentication errors should
           * return to the invitation page.
           */
          const params =
            new URLSearchParams(
              window.location.search
            );

          const kcError =
            params.get(
              'kc_error'
            );

          if (
            kcError
          ) {

            params.delete(
              'kc_error'
            );

            const cleanQuery =
              params.toString();

            window.history.replaceState(
              {},
              document.title,
              `${window.location.pathname}${
                cleanQuery
                  ? `?${cleanQuery}`
                  : ''
              }`
            );

            throw new Error(
              kcError
            );

          }

          /*
           * Check KC/pass status BEFORE drawing the invitation.
           *
           * This also repairs users who authenticated before
           * the local-QR migration:
           *
           * kc_verified=true
           * registrationCode=null
           */
          try {

            const statusResponse =
              await fetch(
                `${API_URL}/api/birthday/kingschat/status/${encodeURIComponent(
                  code
                )}`
              );

            const statusResult =
              await readJson(
                statusResponse
              );

            if (
              statusResponse.ok &&
              statusResult.success
            ) {

              const statusData =
                statusResult.data ||
                {};

              if (
                statusData
                  .registrationCode
              ) {

                if (
                  goToVerify(
                    statusData
                      .registrationCode
                  )
                ) {
                  return;
                }

              }

              if (
                statusData
                  .kc_verified &&
                !statusData
                  .registrationCode
              ) {

                await finalizeVerifiedPass();

                return;

              }

            }

          } catch (
            statusError
          ) {

            console.warn(
              'KingsChat status check failed:',
              statusError
            );

          }

          /*
           * This is now a truly fresh invitation.
           */
          const response =
            await fetch(
              `${API_URL}/api/birthday/invitation/${encodeURIComponent(
                code
              )}`
            );

          const result =
            await readJson(
              response
            );

          if (
            !response.ok ||
            !result.success
          ) {

            throw new Error(
              result.message ||
              'This invitation is unavailable.'
            );

          }

          /*
           * A local pass may already exist even if the status
           * endpoint was temporarily unavailable.
           */
          if (
            result.data
              ?.isRegistered &&
            result.data
              ?.registrationCode
          ) {

            if (
              goToVerify(
                result.data
                  .registrationCode
              )
            ) {
              return;
            }

          }

          if (
            !cancelled
          ) {

            setInvitation(
              result.data
            );

          }

        } catch (
          err
        ) {

          if (
            !cancelled
          ) {

            setError(
              err.message ||
              'This invitation is unavailable.'
            );

          }

        } finally {

          if (
            !cancelled
          ) {

            setLoading(
              false
            );

          }

        }

      };

    loadInvitation();

    return () => {

      cancelled =
        true;

    };

  }, [
    code,
    navigate,
  ]);

  /* =========================================================

     AUTO SLIDER

  ========================================================= */

  useEffect(() => {

    if (

      sliderPaused ||

      CELEBRANT_IMAGES.length <= 1

    ) {

      return undefined;

    }

    const timer =

      window.setInterval(

        () => {

          setActiveSlide(

            (current) =>

              (

                current +

                1

              ) %

              CELEBRANT_IMAGES.length

          );

        },

        SLIDE_INTERVAL_MS

      );

    return () => {

      window.clearInterval(

        timer

      );

    };

  }, [

    sliderPaused,

  ]);

  /* =========================================================

     SLIDER CONTROLS

  ========================================================= */

  const goToPreviousSlide =

    () => {

      setActiveSlide(

        (current) =>

          (

            current -

            1 +

            CELEBRANT_IMAGES.length

          ) %

          CELEBRANT_IMAGES.length

      );

    };

  const goToNextSlide =

    () => {

      setActiveSlide(

        (current) =>

          (

            current +

            1

          ) %

          CELEBRANT_IMAGES.length

      );

    };

  /* =========================================================
     ACCEPT INVITATION

     ONE CLICK ONLY:
     Accept Event
     -> KingsChat login
     -> backend creates/reuses local registration code + QR
     -> backend redirects directly to /verify/:registrationCode

     If KC is already verified, the backend must ensure the
     local pass exists before returning alreadyVerified=true.
  ========================================================= */

  const acceptInvitation =
    async () => {

      try {

        setAccepting(
          true
        );

        setError(
          ''
        );

        const response =
          await fetch(
            `${API_URL}/api/birthday/kingschat/start/${encodeURIComponent(
              code
            )}`
          );

        const result =
          await readJson(
            response
          );

        if (
          !response.ok ||
          !result.success
        ) {

          throw new Error(
            result.message ||
            'Unable to start KingsChat authentication.'
          );

        }

        /*
         * Already authenticated for THIS invitation.
         *
         * With the corrected backend this response already
         * contains registrationCode.
         */
        if (
          result.alreadyVerified
        ) {

          let registrationCode =
            result.data
              ?.registrationCode;

          /*
           * Safety/recovery for records created before the
           * local QR migration.
           */
          if (
            !registrationCode
          ) {

            const finalizeResponse =
              await fetch(
                `${API_URL}/api/birthday/kingschat/finalize/${encodeURIComponent(
                  code
                )}`,
                {
                  method: 'POST',
                }
              );

            const finalizeResult =
              await readJson(
                finalizeResponse
              );

            if (
              !finalizeResponse.ok ||
              !finalizeResult.success
            ) {

              throw new Error(
                finalizeResult.message ||
                'KingsChat is verified, but your local pass could not be created.'
              );

            }

            registrationCode =
              finalizeResult.data
                ?.registrationCode;

          }

          if (
            !registrationCode
          ) {

            throw new Error(
              'KingsChat is verified, but no local registration code is available.'
            );

          }

          navigate(
            `/verify/${encodeURIComponent(
              registrationCode
            )}`,
            {
              replace: true,
            }
          );

          return;

        }

        if (
          !result.authUrl
        ) {

          throw new Error(
            'KingsChat login URL was not returned.'
          );

        }

        /*
         * Do NOT return here to ask the user to confirm again.
         *
         * After KC succeeds, the BACKEND callback redirects
         * directly to:
         *
         * /verify/:registrationCode
         */
        window.location.assign(
          result.authUrl
        );

      } catch (
        err
      ) {

        setError(
          err.message ||
          'Unable to accept this invitation.'
        );

      } finally {

        setAccepting(
          false
        );

      }

    };

/* =========================================================

     OPEN EXISTING PASS

  ========================================================= */

  const openExistingPass =

    () => {

      if (

        !invitation

          ?.registrationCode

      ) {

        setError(

          'No active registration code was found.'

        );

        return;

      }

      navigate(

        `/verify/${encodeURIComponent(

          invitation.registrationCode

        )}`

      );

    };

  /* =========================================================

     DERIVED VALUES

  ========================================================= */

  const dignitaryLevel =

    invitation

      ?.dignitaryLevel ===

      'VVIP'

      ? 'VVIP'

      : 'VIP';

  const isVvip =

    dignitaryLevel ===

    'VVIP';

  const alreadyAccepted =

    Boolean(

      invitation

        ?.isRegistered &&

      invitation

        ?.registrationCode

    );

  const accessItems =

    useMemo(

      () =>

        invitation

          ?.access || [

          'Thanksgiving Service',

          'Reception / Banquet',

        ],

      [

        invitation,

      ]

    );

  /* =========================================================

     LOADING

  ========================================================= */

  if (loading) {

    return (

      <div className="vip-invitation-page">

        <div className="vip-invitation-loading">

          <div className="vip-invitation-spinner" />

          <span>

            Preparing your private invitation…

          </span>

        </div>

      </div>

    );

  }

  /* =========================================================

     HARD ERROR

  ========================================================= */

  if (

    error &&

    !invitation

  ) {

    return (

      <div className="vip-invitation-page">

        <motion.main

          className="vip-invitation-card vip-invitation-card--error"

          initial={{

            opacity:

              0,

            y:

              24,

          }}

          animate={{

            opacity:

              1,

            y:

              0,

          }}

        >

          <div className="vip-invitation-seal vip-invitation-seal--error">

            ×

          </div>

          <span className="vip-invitation-eyebrow">

            Private Invitation

          </span>

          <h1>

            Invitation Unavailable

          </h1>

          <p>

            {error}

          </p>

        </motion.main>

      </div>

    );

  }

  /* =========================================================

     PAGE

  ========================================================= */

  return (

    <div

      className={`vip-invitation-page ${

        isVvip

          ? 'vip-invitation-page--vvip'

          : 'vip-invitation-page--vip'

      }`}

    >

      <div className="vip-invitation-glow vip-invitation-glow--one" />

      <div className="vip-invitation-glow vip-invitation-glow--two" />

      <motion.main

        className={`vip-invitation-card ${

          isVvip

            ? 'vip-invitation-card--vvip'

            : 'vip-invitation-card--vip'

        }`}

        initial={{

          opacity:

            0,

          y:

            28,

          scale:

            0.985,

        }}

        animate={{

          opacity:

            1,

          y:

            0,

          scale:

            1,

        }}

        transition={{

          duration:

            0.55,

        }}

      >

        {/* Decorative corners */}

        <div className="vip-invitation-corner vip-invitation-corner--tl" />

        <div className="vip-invitation-corner vip-invitation-corner--tr" />

        <div className="vip-invitation-corner vip-invitation-corner--bl" />

        <div className="vip-invitation-corner vip-invitation-corner--br" />

        {/* =====================================================

            TOP BRAND AREA

        ===================================================== */}

        <header className="vip-invitation-top">

        </header>

        {/* =====================================================

            PHOTO SLIDER

        ===================================================== */}

        <section

          className="vip-invitation-slider"

          onMouseEnter={() =>

            setSliderPaused(

              true

            )

          }

          onMouseLeave={() =>

            setSliderPaused(

              false

            )

          }

          aria-label="Pastor Bisola Adeyemi photo gallery"

        >

          <AnimatePresence

            mode="wait"

          >

            <motion.img

              key={

                CELEBRANT_IMAGES[

                  activeSlide

                ].src

              }

              src={

                CELEBRANT_IMAGES[

                  activeSlide

                ].src

              }

              alt={

                CELEBRANT_IMAGES[

                  activeSlide

                ].alt

              }

              className="vip-invitation-slide-image"

              style={{

                objectPosition:

                  CELEBRANT_IMAGES[

                    activeSlide

                  ].position,

              }}

              initial={{

                opacity:

                  0,

                scale:

                  1.035,

              }}

              animate={{

                opacity:

                  1,

                scale:

                  1,

              }}

              exit={{

                opacity:

                  0,

              }}

              transition={{

                duration:

                  0.8,

                ease:

                  'easeOut',

              }}

            />

          </AnimatePresence>

          <div className="vip-invitation-slider-overlay" />

          <div className="vip-invitation-slider-copy">

            <span>

              SPECIAL INVITATION TO THE

            </span>

            <strong>

              Thanksgiving &amp; Banquet

            </strong>

          </div>

          {CELEBRANT_IMAGES.length >

            1 && (

            <>

              <button

                type="button"

                className="vip-slider-arrow vip-slider-arrow--left"

                onClick={

                  goToPreviousSlide

                }

                aria-label="Previous photo"

              >

                ‹

              </button>

              <button

                type="button"

                className="vip-slider-arrow vip-slider-arrow--right"

                onClick={

                  goToNextSlide

                }

                aria-label="Next photo"

              >

                ›

              </button>

              <div className="vip-slider-dots">

                {CELEBRANT_IMAGES.map(

                  (

                    item,

                    index

                  ) => (

                    <button

                      key={

                        item.src

                      }

                      type="button"

                      className={`vip-slider-dot ${

                        activeSlide ===

                        index

                          ? 'is-active'

                          : ''

                      }`}

                      onClick={() =>

                        setActiveSlide(

                          index

                        )

                      }

                      aria-label={`Show photo ${

                        index +

                        1

                      }`}

                    />

                  )

                )}

              </div>

              <motion.div

                key={

                  activeSlide

                }

                className="vip-slider-progress"

                initial={{

                  scaleX:

                    0,

                }}

                animate={{

                  scaleX:

                    sliderPaused

                      ? 0

                      : 1,

                }}

                transition={{

                  duration:

                    sliderPaused

                      ? 0

                      : SLIDE_INTERVAL_MS /

                        1000,

                  ease:

                    'linear',

                }}

              />

            </>

          )}

        </section>

        {/* =====================================================

            INVITATION CONTENT

        ===================================================== */}

        <section className="vip-invitation-content">

          <div

            className={`vip-invitation-seal ${

              isVvip

                ? 'vip-invitation-seal--vvip'

                : 'vip-invitation-seal--vip'

            }`}

          >

            {dignitaryLevel}

          </div>

          {/* <p className="vip-invitation-script">

            A Special Invitation

          </p> */}

          <h1>

            You're Specially Invited

          </h1>

          <div className="vip-invitation-divider">

            <span />

            <b>

              ✦

            </b>

            <span />

          </div>

          <h2 className="vip-invitation-name">

            {

              invitation

                ?.fullName

            }

          </h2>

          <section className="vip-invitation-event">

            <span>

              IN HONOUR OF

            </span>

            <h3>

              Highly Esteemed Pastor Bisola Adeyemi

            </h3>

            <p>

              Chief of Staff · LoveWorld Nation

            </p>

          </section>

          {/* ===================================================

              EVENT DETAILS

          =================================================== */}

          <section className="vip-event-details">

            <article className="vip-event-detail">

              <span className="vip-event-detail-icon">

                29

              </span>

              <div>

                <small>

                  DATE

                </small>

                <strong>

                  Tuesday, 6th October 2026

                </strong>

              </div>

            </article>

            <article className="vip-event-detail">

              <span className="vip-event-detail-icon">

                10

              </span>

              <div>

                <small>

                  THANKSGIVING

                </small>

                <strong>

                  Bay 4 · 10:00 AM Prompt

                </strong>

              </div>

            </article>

            <article className="vip-event-detail">

              <span className="vip-event-detail-icon">

                ✦

              </span>

              <div>

                <small>

                  BANQUET

                </small>

                <strong>

                  The Angel Court

                </strong>

                <em>

                  Immediately after the Thanksgiving Service

                </em>

              </div>

            </article>

          </section>

          {/* ===================================================

              ACCESS

          =================================================== */}

          <section className="vip-invitation-access">

            <span className="vip-invitation-access-label">

              YOUR SPECIAL ACCESS

            </span>

            {accessItems.map(

              (

                item

              ) => (

                <div

                  className="vip-invitation-access-row"

                  key={

                    item

                  }

                >

                  <span>

                    ✓

                  </span>

                  <strong>

                    {item}

                  </strong>

                </div>

              )

            )}

          </section>

          {error && (

            <div

              className="vip-invitation-error"

              role="alert"

            >

              {error}

            </div>

          )}

          {/* ===================================================

              ACTION

          =================================================== */}

          {alreadyAccepted ? (

            <div className="vip-invitation-accepted">

              <span>

                ✓ Invitation Accepted

              </span>

              <p>

                Your {dignitaryLevel} registration is already active.

              </p>

              <motion.button

                type="button"

                onClick={

                  openExistingPass

                }

                className="vip-invitation-primary"

                whileHover={{

                  scale:

                    1.01,

                }}

                whileTap={{

                  scale:

                    0.99,

                }}

              >

                View My Verified {dignitaryLevel} Pass

              </motion.button>

            </div>

          ) : (

            <div className="vip-invitation-action">

              <p>

                Click Accept Event once. After KingsChat authentication,
                your verified {dignitaryLevel} pass will open automatically.

              </p>

              <motion.button

                type="button"

                onClick={

                  acceptInvitation

                }

                className="vip-invitation-primary"

                disabled={

                  accepting

                }

                whileHover={

                  !accepting

                    ? {

                        scale:

                          1.01,

                      }

                    : {}

                }

                whileTap={

                  !accepting

                    ? {

                        scale:

                          0.99,

                      }

                    : {}

                }

              >

                {accepting
                  ? 'Opening KingsChat…'
                  : 'Accept Event'}

              </motion.button>

            </div>

          )}

          <div className="vip-invitation-ornament">

            <span />

            <b>

              ✦

            </b>

            <b>

              ✦

            </b>

            <b>

              ✦

            </b>

            <span />

          </div>

          <p className="vip-invitation-private">

            Private invitation · Intended recipient only

          </p>

        </section>

      </motion.main>

    </div>

  );

}
